import { logReportDownload } from '../../util/auditLogger';
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import xlsxStyle from "xlsx-js-style";

const BANKS = [
  { name: "ธนาคารกรุงเทพฯ", code: "002 กรุงเทพ", type: "bbl" },
  { name: "ธนาคารไทยพาณิชย์", code: "014 ไทยพาณิชย์", type: "scb" },
  { name: "ธนาคารกสิกรไทย", code: "004 กสิกรไทย", type: "kbank" },
  { name: "ธนาคารกรุงศรีอยุธยา", code: "025 กรุงศรีอยุธยา", type: "nonscb" },
  { name: "ธนาคารกรุงไทย", code: "006 กรุงไทย", type: "ktb" },
  { name: "ธนาคารทิสโก้", code: "067 ทิสโก้", type: "nonscb" },
  { name: "ธนาคารออมสิน", code: "030 ออมสิน", type: "nonscb" },
  { name: "ธนาคารอาคารสงเคราะห์", code: "033 อาคารสงเคราะห์", type: "nonscb" },
  {
    name: "ธนาคารอิสลามแห่งประเทศไทย",
    code: "066 อิสลามแห่งประเทศไทย",
    type: "nonscb",
  },
  {
    name: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
    code: "034 เพื่อการเกษตรและสหกรณ์",
    type: "nonscb",
  },
  {
    name: "ธนาคารทหารไทยธนชาต",
    code: "011 ทหารไทยธนชาต จำกัด (มหาชน)",
    type: "nonscb",
  },
  { name: "ธนาคารซีไอเอ็มบีไทย", code: "022 ซีไอเอ็มบี", type: "nonscb" },
  { name: "ธนาคารยูโอบี", code: "024 ยูโอบี", type: "nonscb" },
  {
    name: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
    code: "073 แลนด์แอนด์เฮ้าส์",
    type: "nonscb",
  },
  { name: "ธนาคารเกียรตินาคินภัทร", code: "069 เกียรตินาคิน", type: "nonscb" },
  {
    name: "Joint Development Bank",
    code: "Joint Development Bank",
    type: "lao",
  },
  {
    name: "Banque Pour Le Commerce Exterieur Lao Public",
    code: "Banque Pour Le Commerce Exterieur Lao Public",
    type: "lao",
  },
  { name: "Lao-Viet Bank Co,Ltd", code: "Lao-Viet Bank Co,Ltd", type: "lao" },
  { name: "BIC Bank Lao Co., Ltd", code: "BIC Bank Lao Co., Ltd", type: "lao" },
  { name: "Lao Development Bank", code: "Lao Development Bank", type: "lao" },
  { name: "Indochina Bank LTD", code: "Indochina Bank LTD", type: "lao" },
  {
    name: "Maruhan Japan Bank Lao Co.,ltd",
    code: "Maruhan Japan Bank Lao Co.,ltd",
    type: "lao",
  },
  {
    name: "Agricultural Promotion Bank",
    code: "Agricultural Promotion Bank",
    type: "lao",
  },
  {
    name: "Military Commercial Joint Stock Bank - Laos Branch",
    code: "Military Commercial Joint Stock Bank - Laos Branch",
    type: "lao",
  },
  {
    name: "KasikornBank in Lao PDR",
    code: "KasikornBank in Lao PDR",
    type: "lao",
  },
  {
    name: "VietinBank Lao limited",
    code: "VietinBank Lao limited",
    type: "lao",
  },
  { name: "Acleda Bank Lao Ltd", code: "Acleda Bank Lao Ltd", type: "lao" },
  { name: "Banque Franco-Lao Ltd", code: "Banque Franco-Lao Ltd", type: "lao" },
  { name: "Phongsavanh Bank", code: "Phongsavanh Bank", type: "lao" },
  { name: "ST Bank LTD", code: "ST Bank LTD", type: "lao" },
];

const XLSX_HEADERS = [
  "ธนาคาร",
  "เลขบัญชี",
  "ชื่อบัญชี",
  "ชื่อ-นามสกุล",
  "จำนวนเงิน",
  "เลขที่อ้างอิง",
  "ค่าธรรมเนียม",
  "รหัสสาขา",
  "เบอร์โทรศัพท์",
  "อีเมล์",
];

const isNoBank = (prize) => !prize.bankName || !prize.accName || !prize.accNo;

const enrichPrize = (prize) => {
  if (prize.bankName === "Alipay" || prize.paymentMethod === "ALIPAY") {
    return { ...prize, code: "ALIPAY", type: "alipay" };
  }
  const bank = BANKS.find((b) => b.name === prize.bankName);
  return {
    ...prize,
    code: bank?.code || "-",
    type: bank?.type,
  };
};

export const ReportWinner = () => {
  const { callApi, configs } = Context();
  const [prizes, setPrizes] = useState(false);
  const [originalPrizes, setOriginalPrizes] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState(false);

  const getOrders = async () => {
    setLoading(true);
    const data = await callApi("userPrizes-getAll", {
      limit: 10000,
      startAfter: "",
      queries: [],
      roundDate: selectedRoundDate,
    });
    const mapped = data.map(enrichPrize);
    setPrizes(mapped);
    setOriginalPrizes(mapped);
    setLoading(false);
  };

  const downloadAll = () => {
    const downloadTasks = [
      { prizes: originalPrizes, type: "all" },
      {
        prizes: originalPrizes.filter((p) => p.type === "kbank" && !isNoBank(p)),
        type: "ธนาคารกสิกรไทย",
      },
      {
        prizes: originalPrizes.filter((p) => p.type === "scb" && !isNoBank(p)),
        type: "ธนาคารไทยพาณิชย์",
      },
      {
        prizes: originalPrizes.filter((p) => p.type === "ktb" && !isNoBank(p)),
        type: "ธนาคารกรุงไทย",
      },
      {
        prizes: originalPrizes.filter((p) => p.type === "bbl" && !isNoBank(p)),
        type: "ธนาคารกรุงเทพฯ",
      },
      { prizes: originalPrizes.filter(isNoBank), type: "no_bank" },
      {
        prizes: originalPrizes.filter((p) => p.type === "nonscb" && !isNoBank(p)),
        type: "nonscb",
      },
      {
        prizes: originalPrizes.filter((p) => p.type === "lao" && !isNoBank(p)),
        type: "lao",
      },
    ];
    for (const task of downloadTasks) {
      if (task.prizes?.length > 0) {
        handleDownload(task.prizes, task.type);
      }
    }
  };

  const handleDownload = (prizes, type) => {
    const data = [XLSX_HEADERS];
    prizes.forEach((value) => {
      const amount = type === "lao" ? value.totalPrizes_lak : value.totalPrizes;
      data.push([
        value.bankName && value.code,
        value.accNo && value.accNo.split("-").join(""),
        value.accName && value.accName,
        `${value.firstName} ${value.lastName}`,
        typeof amount === "number" ? parseFloat(amount.toFixed(2)) : amount,
        value.userId,
        "Payer (OUR)",
        "0001",
        value.phone,
        value.email || "admin.mg@hongthongofficial.com",
      ]);
    });
    const ws = xlsxStyle.utils.aoa_to_sheet(data);

    // Apply cell styles: all left, column E (totalPrizes) right-aligned with 2 decimals
    const range = xlsxStyle.utils.decode_range(ws["!ref"]);
    for (let R = 0; R <= range.e.r; R++) {
      for (let C = 0; C <= range.e.c; C++) {
        const cellAddr = xlsxStyle.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddr]) continue;
        const isTotalPrizesCol = C === 4 && R > 0;
        ws[cellAddr].s = {
          alignment: { horizontal: isTotalPrizesCol ? "right" : "left" },
          ...(isTotalPrizesCol ? { numFmt: "#,##0.00" } : {}),
        };
      }
    }

    const wb = xlsxStyle.utils.book_new();
    xlsxStyle.utils.book_append_sheet(wb, ws, "Sheet1");
    logReportDownload();
    xlsxStyle.writeFile(
      wb,
      `รายงานผู้ถูกรางวัล-${selectedRoundDate}-${type}.xlsx`,
    );
  };

  const onFilterChange = (e) => {
    const value = e.target.value;
    setPrizes(
      originalPrizes.filter((prize) => {
        if (value === "all") return true;
        if (value === "no_bank") return isNoBank(prize);
        return prize.type === value && !isNoBank(prize);
      }),
    );
  };

  const counts = originalPrizes
    ? {
      all: originalPrizes.length,
      kbank: originalPrizes.filter((p) => p.type === "kbank" && !isNoBank(p)).length,
      scb: originalPrizes.filter((p) => p.type === "scb" && !isNoBank(p)).length,
      ktb: originalPrizes.filter((p) => p.type === "ktb" && !isNoBank(p)).length,
      bbl: originalPrizes.filter((p) => p.type === "bbl" && !isNoBank(p)).length,
      noBank: originalPrizes.filter(isNoBank).length,
      nonscb: originalPrizes.filter((p) => p.type === "nonscb" && !isNoBank(p)).length,
      lao: originalPrizes.filter((p) => p.type === "lao" && !isNoBank(p)).length,
    }
    : null;

  const SUMMARY_ROWS = counts
    ? [
      { label: "รางวัลทั้งหมด", count: counts.all },
      { label: "ธนาคารกสิกรไทย", count: counts.kbank },
      { label: "ธนาคารไทยพาณิชย์", count: counts.scb },
      { label: "ธนาคารกรุงไทย", count: counts.ktb },
      { label: "ธนาคารกรุงเทพฯ", count: counts.bbl },
      { label: "no_bank", count: counts.noBank },
      { label: "nonscb", count: counts.nonscb },
      { label: "lao", count: counts.lao },
    ]
    : [];

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24 mx-auto">
      <Header
        header="Report"
        subHeader="รายงานรางวัล"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold">รางวัล</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <select
              className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
              value={selectedRoundDate}
              onChange={(e) => setSelectedRoundDate(e.target.value)}
            >
              {configs.roundDates.map((roundDate) => (
                <option key={roundDate} value={roundDate}>
                  {roundDate}
                </option>
              ))}
            </select>
          </div>

          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">ประเภท</p>
            <select
              className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
              onChange={onFilterChange}
            >
              <option value="all">all</option>
              <option value="kbank">ธนาคารกสิกรไทย</option>
              <option value="scb">ธนาคารไทยพาณิชย์</option>
              <option value="ktb">ธนาคารกรุงไทย</option>
              <option value="bbl">ธนาคารกรุงเทพฯ</option>
              <option value="no_bank">no_bank</option>
              <option value="nonscb">nonscb</option>
              <option value="lao">lao</option>
            </select>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={getOrders}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!prizes?.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={downloadAll}
          >
            ดาวโหลด
          </button>
        </div>
      </div>

      {counts && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          {SUMMARY_ROWS.map(({ label, count }) => (
            <div
              key={label}
              className="flex bg-white gap-3 items-center p-3 border-b border-gray-300"
            >
              <p className="font-semibold">{label}</p>
              <p className="text-xs font-semibold text-[#969797]">
                {count} รางวัล
              </p>
            </div>
          ))}
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold">รวม</p>
            <p className="text-xs font-semibold text-[#969797]">
              {counts.kbank}+{counts.scb}+{counts.ktb}+{counts.bbl}+
              {counts.noBank}+{counts.nonscb}+{counts.lao} ={" "}
              {counts.kbank +
                counts.scb +
                counts.ktb +
                counts.bbl +
                counts.noBank +
                counts.nonscb +
                counts.lao}
            </p>
          </div>
        </div>
      )}

      {prizes && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold">รางวัลทั้งหมด</p>
            <p className="text-xs font-semibold text-[#969797]">
              {prizes.length} รางวัล
            </p>
          </div>
          <Table>
            <TableHeader className="bg-[#f2f3f5]">
              <TableRow>
                <TableHead className="text-center">ลำดับ</TableHead>
                <TableHead>ธนาคาร</TableHead>
                <TableHead>เลขบัญชี</TableHead>
                <TableHead>ชื่อบัญชี</TableHead>
                <TableHead className="text-right">รหัสผู้ใช้</TableHead>
                <TableHead>ชื่อ-นามสกุล</TableHead>
                <TableHead>เบอร์โทรศัพท์</TableHead>
                <TableHead className="text-right">จำนวนเงิน</TableHead>
                <TableHead>ซื้อให้ผู้อื่น</TableHead>
                <TableHead>ข่องทางการชำระเงิน</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {prizes.length > 0 ? (
                prizes.map((order, index) => (
                  <TableRow key={index}>
                    <TableCell className="font-medium text-center">
                      {index + 1}
                    </TableCell>
                    <TableCell className="font-medium">
                      {order?.code || "-"}
                    </TableCell>
                    <TableCell>
                      {order.accNo ? order.accNo.split("-").join("") : "-"}
                    </TableCell>
                    <TableCell>{order.accName || "-"}</TableCell>
                    <TableCell className="font-semibold text-right">
                      {order.userId}
                    </TableCell>
                    <TableCell className="font-medium">
                      {order.firstName} {order.lastName}
                    </TableCell>
                    <TableCell className="font-medium">
                      {order.phone || "-"}
                    </TableCell>
                    <TableCell className="font-semibold text-right">
                      {order.totalPrizes.toLocaleString()}
                    </TableCell>
                    <TableCell className="font-bold text-green">
                      {order.isBuyForSomeoneElse ? "Yes" : ""}
                    </TableCell>
                    <TableCell className="font-bold text-green">
                      {order.deliverChannel || "-"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="8">
                    <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
